import React from "react";

import { Editor } from "~/components/code/editor";
import { FormField } from "~/components/form/field";

import type { FormState } from "../_form-state";

import { useYamlForm } from "./_use-yaml-form";

export interface YamlProps {
	form: FormState;
}

export const Yaml: React.FC<YamlProps> = ({ form }) => {
	const unit = useYamlForm(form);

	return (
		<FormField state={unit}>
			{(monitor, field) => (
				<Editor
					height="auto"
					language="yaml"
					onChange={(input) => field.setInput(input)}
					value={field.getInput(monitor)}
				/>
			)}
		</FormField>
	);
};
